import { render, staticRenderFns } from "./ProgramDashboard.vue?vue&type=template&id=5a6ee2c6&scoped=true"
import script from "./ProgramDashboard.vue?vue&type=script&lang=js"
export * from "./ProgramDashboard.vue?vue&type=script&lang=js"
import style0 from "./ProgramDashboard.vue?vue&type=style&index=0&id=5a6ee2c6&prod&scoped=true&lang=css"


/* normalize component */
import normalizer from "!../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "5a6ee2c6",
  null
  
)

export default component.exports